import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/index.css.json';


const propTypes = {
  children: PropTypes.node.isRequired,
};

const AlertsBoxWrapper = ({ children }) => (
  <div className={styles.alertsBoxWrapper}>{children}</div>
);

AlertsBoxWrapper.propTypes = propTypes;

export default AlertsBoxWrapper;
